import { HttpInterceptorFn } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

export interface ApiError {
    status: string;
    error: {
        code: string;
        message: string;
        details?: Record<string, unknown>;
    };
    request_id: string;
    timestamp: string;
}

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
    return next(req).pipe(
        catchError((error) => {
            let apiError: ApiError;

            if (error.error && error.error.status === 'error') {
                apiError = error.error as ApiError;
            } else {
                apiError = {
                    status: 'error',
                    error: {
                        code: 'HTTP_ERROR',
                        message: error.message || 'An unexpected error occurred.',
                    },
                    request_id: '',
                    timestamp: new Date().toISOString(),
                };
            }

            return throwError(() => apiError);
        }),
    );
};
